import { render } from "./PerformanceBy.vue?vue&type=template&id=34c5ddfc&scoped=true"
import script from "./PerformanceBy.vue?vue&type=script&lang=js"
export * from "./PerformanceBy.vue?vue&type=script&lang=js"

import "./PerformanceBy.vue?vue&type=style&index=0&id=34c5ddfc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c5ddfc"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QDialog});
